import { l10nEnService } from '@uplift/services';
import { object, string, mixed } from 'yup';
import { VALIDATION_CARD_NUMBER, VALIDATION_CARD_CVC, VALIDATION_CARD_EXP_DATE, applyNameValidator } from '@uplift/validations';
import { settingsAddressValidation } from '@uplift/ui-v2';
import { AddressType } from '@uplift/types';

export type PaymentInfoFormType = {
  nameOnCard: string;
  cardNumber: string;
  expirationDate: string;
  cvc: string;
  billingAndHomeAddressSame: boolean;
  address?: AddressType;
};

export const paymentInfoValidation = (l10n: typeof l10nEnService) => {
  return object({
    nameOnCard: applyNameValidator(string())
      .required(l10n.validations.client.nameOnCard.empty),
    cardNumber: VALIDATION_CARD_NUMBER,
    expirationDate: VALIDATION_CARD_EXP_DATE,
    cvc: VALIDATION_CARD_CVC,
    address: mixed()
      .when('billingAndHomeAddressSame', {
        is: true,
        then: null,
        otherwise: _s => settingsAddressValidation(l10n),
      }),
  });
};
